import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SDKDatagridComponent } from './sdk-datagrid.component';

@NgModule({
  imports: [
    SDKDatagridComponent,
  ],
  exports: [
    SDKDatagridComponent
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})
export class SDKDatagridModule { }
